<template>
  <div class="p-contentplans-writing-user-fieldset">
    <div class="p-contentplans-writing-user-fieldset__header">
      <h4 class="p-contentplans-writing__title--sub">
        ディスクリプション案
      </h4>
      <p class="p-contentplans-writing__note">
        <span class="p-contentplans-writing__count">{{ count }}</span
        >/ 推奨120文字 (最大{{ maxLength }}文字)
      </p>
    </div>
    <div v-if="isEditMode" class="c-alertPos">
      <Textarea
        :value="value"
        autosize
        :rows="1"
        placeholder="AIが生成したテキストをここで編集できます"
        :class="{ alert: error }"
        ref="input"
        @input="input"
      />
      <Alert v-if="error">{{ error }}</Alert>
    </div>
    <p v-else>{{ value }}</p>
  </div>
</template>

<script>
import Alert from '@/components/Alert';
import Textarea from '@/components/Textarea';

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    error: {
      type: String,
      required: false
    },
    maxLength: {
      type: Number,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    isEditMode: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Alert,
    Textarea
  },
  computed: {
    count() {
      return this.value.length;
    }
  },
  methods: {
    focusInput() {
      this.$refs.input.$el.focus();
    },
    input(value) {
      this.$emit('input', value);
    }
  }
};
</script>
